import { STEPS } from "pages/tours/create/constants";

export const showTotalPrice = (total) => 
  `$${Number.parseFloat(total || 0).toFixed(STEPS.fixedCount)}`;